module.exports = __webpack_public_path__ + "static/fon_image-11af09e30011f9e6a46a1eece86833dd.png";